import React from 'react';
import gameAsPerformance1 from '../../assets/img/projects/gameAsPerformance1.jpg'
import gameAsPerformance2 from '../../assets/img/projects/gameAsPerformance2.jpg'
import gameAsPerformance3 from '../../assets/img/projects/gameAsPerformance3.jpg'
import gameAsPerformance4 from '../../assets/img/projects/gameAsPerformance4.jpg'

//TODO: create a grid from the images below
// import theMofG0 from '../../assets/img/projects/theMofG0.png';
// import theMofG1 from '../../assets/img/projects/theMofG1.png';
// import theMofG2 from '../../assets/img/projects/theMofG2.png';
// import theMofG3 from '../../assets/img/projects/theMofG3.png';
// import theMofG4 from '../../assets/img/projects/theMofG4.png';
// import theMofG5 from '../../assets/img/projects/theMofG5.png';
// import theMofG6 from '../../assets/img/projects/theMofG6.png';
// import theMofG7 from '../../assets/img/projects/theMofG7.png';
// import theMofG8 from '../../assets/img/projects/theMofG8.png';

const GameAsPerformance = () =>
{
    console.log('rendered');
    return(
        <div>
           <Text/>
            <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ gameAsPerformance1 }
                alt="gameAsPerformance1"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ gameAsPerformance2 }
                alt="gameAsPerformance2"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ gameAsPerformance3 }
                alt="gameAsPerformance3"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ gameAsPerformance4 }
                alt="gameAsPerformance4"
            />
            <br></br>
            <br></br>
        </div>
    );
}

export default GameAsPerformance;

const Text = () =>
{
    return(
        <div className="Project-Content">
            The Meaning of Game is an art game that explores the aesthetic and performative effect of computer games when they are contextualised as artworks. 
            <br></br>
            <br></br>
            The story takes place on four virtual levels and traverses a complex world inhabited by interconnected, abstract digital structures. 
            <br></br>
            <br></br>
            The main character's routine embodies man's existential search for meaning that may not exist but could be found in every moment of living. By playing through the game audience is invited to actively contemplate about ontology, happiness, and purpose.
            <br></br>
            <br></br>
        </div>
    );
};